import { Component } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';

@Component({
  selector: 'cart-number',
  templateUrl: './cart-number.component.html',
  styleUrl: './cart-number.component.scss',
  standalone: false,
})
export class CartNumberComponent {
  cart$ = this.activeCartService.getActive();

  constructor(private activeCartService: ActiveCartFacade) {}
}
